/** Validated client-side environment access. Fails fast if misconfigured. */

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing environment variable ${name}. Copy .env.example to .env and fill it in.`,
    );
  }
  return value;
}

export const env = {
  supabaseUrl: required("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required("VITE_SUPABASE_ANON_KEY", import.meta.env.VITE_SUPABASE_ANON_KEY),
  appPublicUrl:
    import.meta.env.VITE_APP_PUBLIC_URL ??
    (typeof window !== "undefined" ? window.location.origin : ""),
  // Optional. When set, the registration form shows a Cloudflare Turnstile
  // challenge and the server verifies the token. Unset => no captcha (dev).
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined,
};
